import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  // Theme is locked to dark for now: the BarberPass Design System tokens are
  // dark-only, so light mode renders broken (e.g. tables). Keep the API stable
  // so existing consumers keep working, but always resolve to dark.
  private currentTheme: 'light' | 'dark' = 'dark';

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initializeTheme();
  }

  private initializeTheme() {
    this.currentTheme = 'dark';
    this.updateBodyClass();
  }

  initTheme() {
    this.initializeTheme();
  }

  toggleTheme() {
    // No-op: light mode is disabled for now.
    this.initializeTheme();
  }

  private updateBodyClass() {
    const body = document.body;
    this.renderer.removeClass(body, 'light-theme');
    this.renderer.addClass(body, 'dark-theme');
  }

  getCurrentTheme(): 'light' | 'dark' {
    return this.currentTheme;
  }
}
